import {ValueObject} from '@s-ui/domain'

export class NavigationDataValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.nextPageUrl
   * @param {String} deps.prevPageUrl
   * @param {String} deps.searchUrl
   * @param {Array<id: Number, url: String>} deps.items
   */

  getItems = () => this._items
  getNextPageUrl = () => this._nextPageUrl
  getPrevPageUrl = () => this._prevPageUrl
  getSearchUrl = () => this._searchUrl
}
